<template>
  <eg-b-container>
    <div
      v-if="assignments.length > 0 && !loading"
      class="text-right svg-container"
    >
      <img
        src="../../assets/illustrations/assignment-illustration.svg"
        alt=""
      />
    </div>
    <section v-if="loading">
      <eg-b-row class="mt-4">
        <eg-b-col class="mb-3" cols="4">
          <eg-b-skeleton-img no-aspect height="150px"></eg-b-skeleton-img>
        </eg-b-col>
        <eg-b-col class="mb-3" cols="4">
          <eg-b-skeleton-img no-aspect height="150px"></eg-b-skeleton-img>
        </eg-b-col>
        <eg-b-col class="mb-3" cols="4">
          <eg-b-skeleton-img no-aspect height="150px"></eg-b-skeleton-img>
        </eg-b-col>
        <eg-b-col cols="4">
          <eg-b-skeleton-img no-aspect height="150px"></eg-b-skeleton-img>
        </eg-b-col>
        <eg-b-col cols="4">
          <eg-b-skeleton-img no-aspect height="150px"></eg-b-skeleton-img>
        </eg-b-col>
        <eg-b-col cols="4">
          <eg-b-skeleton-img no-aspect height="150px"></eg-b-skeleton-img>
        </eg-b-col>
      </eg-b-row>
    </section>
    <section>
      <template
        v-if="
          assignments.length > 0 ||
          debouncedSearchText !== '' ||
          selectedClass !== null
        "
      >
        <eg-b-row class="mb-3">
          <eg-b-col lg="8" md="12">
            <h1>{{ $t("common.assignments") }}</h1>
          </eg-b-col>
          <eg-b-col class="text-right create-rubric-column" lg="4" md="12">
            <eg-b-button variant="info" to="/assignment/new">{{
              $t("common.newAssignment")
            }}</eg-b-button>
          </eg-b-col>
        </eg-b-row>
        <eg-b-row class="mb-3">
          <div class="search-input-wrapper ml-3 mr-3">
            <eg-b-form-input
              ref="searchInput"
              v-model="searchText"
              class="pr-4"
              size="sm"
              type="text"
              :placeholder="$t('assignments.filterByTitle')"
              @input="changeSearch($event)"
            ></eg-b-form-input>
            <eg-b-icon
              v-if="searchText"
              class="clear-input"
              icon="x-circle-fill"
              style="color: #adb5bd"
              @click="clearSearch"
            />
          </div>
          <class-select
            class="select-class"
            size="sm"
            :value="selectedClass"
            @input="selectClass"
          />
        </eg-b-row>
        <eg-b-row>
          <eg-b-col
            v-for="assignment in assignments"
            :key="assignment.id"
            lg="4"
          >
            <assignment-card :assignment="assignment" />
          </eg-b-col>
        </eg-b-row>
        <eg-b-row>
          <eg-b-col>
            <div class="d-flex justify-content-center">
              <eg-b-pagination
                v-model="currentPage"
                :total-rows="count"
                :per-page="limit"
                @change="fetchAssignments"
              >
              </eg-b-pagination>
            </div>
          </eg-b-col>
        </eg-b-row>
      </template>
      <empty-state
        v-else-if="
          !loading &&
          assignments.length == 0 &&
          debouncedSearchText === '' &&
          selectedClass === null
        "
        class="mt-5"
        :title="$t('assignments.noAssignmentsYet')"
        :description="$t('assignments.noAssignmentsDescription')"
        :button-text="$t('common.newAssignment')"
        button-path="/assignment/new"
      >
        <img
          src="../../assets/illustrations/empty-state-assignment.svg"
          alt="EssayGrader Empty State"
        />
      </empty-state>
    </section>
  </eg-b-container>
</template>

<script>
import { getAssignments } from "@/api";
import AssignmentCard from "@/components/assignment/assignment_card.vue";
import EmptyState from "@/components/global/empty_state.vue";
import debounce from "@/utils/debounce";
import ClassSelect from "@/components/classes/class_select";

export default {
  name: "AssignmentView",
  components: {
    AssignmentCard,
    ClassSelect,
    EmptyState,
  },
  data() {
    return {
      selectedClass: null,
      searchText: "",
      debouncedSearchText: "",
      loading: true,
      assignments: [],
      count: 0,
      limit: null,
      currentPage: 1,
    };
  },
  mounted() {
    this.fetchAssignments();
  },
  methods: {
    clearSearch() {
      this.searchText = "";
      this.debouncedSearchText = "";
      this.currentPage = 1;
      this.fetchAssignments();
    },
    selectClass(value) {
      this.selectedClass = value;
      this.currentPage = 1;
      this.fetchAssignments();
    },
    changeSearch: debounce(function (value = "") {
      if (
        value.length >= 2 ||
        (this.debouncedSearchText.length >= 2 && value.length === 0)
      ) {
        this.debouncedSearchText = value;
        this.currentPage = 1;
        this.fetchAssignments();
      }
    }, 500),
    async fetchAssignments() {
      const params = {
        page: this.currentPage,
      };

      if (this.debouncedSearchText) {
        params.title = this.debouncedSearchText;
      }

      if (this.selectedClass) {
        params.ClassId = this.selectedClass.id;
      }

      try {
        const { data } = await getAssignments(params);

        this.assignments = data.rows;
        this.limit = data.limit;
        this.count = data.count;

        this.loading = false;
        this.error = false;
      } catch (error) {
        this.error = error.response?.data?.error;
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.select-class {
  border-radius: 4px;
  background-color: white;
  width: 200px;
}

.search-input-wrapper {
  position: relative;
  width: 200px;

  .clear-input {
    position: absolute;
    bottom: 8px;
    right: 10px;
    cursor: pointer;
  }
}
</style>
